

export default {
    appShell: {
    "menuLabels": [
        "行情工具",
        "合約工具",
        "鏈上探索",
        "資訊分類"
    ],
    "closeMenu": "關閉選單",
    "menuDescriptions": {
        "collect": "追蹤你收藏的幣種",
        "platform": "查看交易所排名與成交量",
        "toolOutsidePrice": "比較場外交易價格",
        "toolOutsideDisk": "觀察全球市場走勢",
        "toolSentimentIndex": "查看恐慌與貪婪指數",
        "manyEmpty": "比較多空持倉與交易比例",
        "hyperliquid": "監控 Hyperliquid 巨鯨持倉",
        "rate": "比較各交易所資金費率",
        "toolLargeIncrease": "追蹤大戶增加持倉",
        "toolLargeDecrease": "追蹤大戶減少持倉",
        "newChain": "探索新上線的代幣",
        "whale": "查看巨鯨與機構持倉",
        "trace": "追蹤收藏地址的動向",
        "inscription": "探索銘文市場數據",
        "toolStableCoin": "供應量、溢價與發行趨勢",
        "toolCompanyHoldings": "查看企業 BTC 持倉",
        "toolMTGoxMonitor": "追蹤 Mt. Gox 錢包轉出",
        "toolBlockChainBrowser": "前往各鏈的區塊瀏覽器",
        "calendar": "查看重要經濟事件與日程",
        "forum": "瀏覽社群文章與討論",
        "application": "探索市場相關應用與資源"
    }
,
    "back": "返回",
    "switchPage": "切換頁面",
    "collapse": "收起",
    "intro": "行情、情緒與資金動向。",
    "home": "TokenTrend 首頁",
    "externalLink": "外部網站",
    "openExternal": "開啟網站",
    "externalBridgeHint": "即將離開 TokenTrend，前往外部網站。開啟後可從螢幕左緣往右滑返回。",
    "light": "切換淺色模式",
    "dark": "切換深色模式",
    "search": "搜尋幣種",
    "closeSearch": "關閉搜尋",
    "brandTagline": "行情 · 情緒 · 資金",
    "greetingMorning": "早安，",
    "greetingAfternoon": "午安，",
    "greetingEvening": "晚安，",
    "darkModeLabel": "深色模式",
    "appearance": "外觀",
    "themeLight": "淺色",
    "themeDark": "深色",
    "notifications": "通知",
    "closeNotifications": "關閉通知",
    "notifySample": [
        { "title": "比特幣守住 77,000 美元", "body": "隔夜盤後 BTC 維持穩健。" },
        { "title": "資金費率大致平衡", "body": "主要交易所仍接近中性。" },
        { "title": "市場情緒中性", "body": "恐慌貪婪指數仍在區間中段。" }
    ],
    "workspace": "市場工作空間",
    "categories": "頁面分類",
    "navigation": "主要導覽",
    "groups": [
        "行情",
        "合約",
        "鏈上",
        "資訊",
        "我的"
    ],
    "pages": {
        "market": "市場行情",
        "platform": "交易平台",
        "manyEmpty": "多空分析",
        "hyperliquid": "Hyperliquid巨鯨監控",
        "hyperliquidDetails": "Hyperliquid持倉",
        "whale": "巨鯨與持倉",
        "burst": "爆倉數據",
        "calendar": "經濟日曆",
        "burstHeatmapDetails": "爆倉熱力圖",
        "burstCoinStatisticsDetails": "幣種爆倉統計",
        "rate": "資金費率",
        "application": "應用資源",
        "publicChain": "公鏈數據",
        "newChain": "新幣",
        "inscription": "銘文",
        "consult": "資訊",
        "solswap": "代幣兌換",
        "my": "帳戶中心",
        "signIn": "每日簽到",
        "contractCheck": "合約檢查",
        "userHitNewRobotInfo": "代幣交易資訊",
        "calendarDetail": "經濟事件詳情",
        "consultDetails": "文章詳情",
        "newCoinDetails": "新幣詳情",
        "firmOffer": "實盤交易"
    }
},
    common: {
        empty: '暫無數據',
        listLoading: '載入中...',
        listNoMore: '沒有更多了',
        tenThousand: "萬",
        hundredMillion: "億",
        copy: '複製',
        copySuccess: '複製成功！ ',
        sendSuccess: '發送成功！ ',
        confirmText: '確認',
        cancelText: '取消',
        privacy: "隱私政策",
        contact: '聯絡我們',
    },
    contact: {
        title: '聯繫我們',
        info1: 'TokenTrend',
        info2: '郵箱:',
    },
    homeNav: {
        market: '行情',
        platform: '平台',
        manyEmpty: '多空',
        whale: '大鯨',
        burst: '爆倉',
        rate: '費率',
        calendar: '日曆',
        inscription: '銘文',
        application: '應用',
        searchPlaceholder: '地址或幣種查詢',
        searchTitle1: '合約',
        searchTitle2: '幣種',
        searchList1: '鏈上交易額',
        searchList2: '流通數量',
        searchNoResult: '暫無搜尋結果',
        historyTitle: '歷史搜尋記錄'
    },
    calendar: {
        title: '日曆',
        tit1: '只看重要',
        tit2: '經濟數據',
        tit3: '事件',
        week0: '週日',
        week1: '週一',
        week2: '週二',
        week3: '週三',
        week4: '週四',
        week5: '週五',
        week6: '週六',
        tab1: '數據/時間',
        tab2: '前值/預測',
        tab3: '重要性/公佈',
        event1: '國家/時間',
        event2: '事件/重要性',
    },
    calendar_details: {
        label1: '最新發布',
        label2: '公布值',
        label3: '預測值',
        label4: '前值',
        label5: '下次公布時間',
        label6: '發布頻率',
        label7: '重要性',
        label8: '數據釋義',
        label9: '數據影響',
        label10: '統計方法',
        label11: '公布機構',
        label12: '歷史數據',
        label13: '1年',
        label14: '2年',
        label15: '5年',

"title": "經濟日曆詳情"
},
    footerNav: {
        publicChain: '公鏈',
        newChain: '打新',
        inscription: '銘文',
        smartMoney: '聰明錢',
        consult: '新聞',
        calendar: '非農日曆',
        my: '我的',
    },
    login: {
        title: '登入',
        enterUserName: '請輸入電子郵件/使用者名稱',
        enterPassword: '請輸入密碼',
        enterLogin: '登入',
        loginTip: '登入...',
        forgotPassword: '忘記密碼',
        register: '註冊帳號',
    },
    register: {
        title: '註 冊',
        enterUserName: '使用者名稱',
        enterPassword: '密碼',
        enterEmail: '電子郵件',
        enterCode: '郵箱驗證碼',
        inviteCode: '邀請碼（可選）',
        sendEmailCode: '發送驗證碼',
        enterUserNameErr: '請輸入使用者名稱',
        enterUserNameErr2: '使用者名稱由6～16位字母或數字組成',
        enterPasswordErr: '請輸入密碼',
        enterPasswordErr2: '密碼由8~18位英文字母、數字、特殊符號組成',
        enterEmailErr: '請輸入電子郵件',
        enterEmailErr2: '請輸入正確的電子郵件信箱',
        enterCodeErr: '請輸入信箱驗證碼',
        enterRegister: '註冊',
        registerSuccess: '註冊成功，即將跳轉登入頁面...',
        toLogin: '已有帳號？直接登入',
        emailCodeTip: '如果您在收件箱中未收到郵件，那可能是被誤判為垃圾郵件了，請去郵箱垃圾箱中查看。'
    },
    userDelete: {
        title: "刪除帳號",
        enterUserName: "用戶名",
        enterPassword: "密碼",
        enterEmail: "電子郵箱",
        enterCode: "郵箱驗證碼",
        sendEmailCode: "發送驗證碼",
        enterUserNameErr: "請輸入用戶名",
        enterPasswordErr: "請輸入密碼",
        enterEmailErr: "請輸入電子郵箱",
        enterCodeErr: "請輸入郵箱驗證碼",
        enterRegister: "確認刪除",
        registerSuccess: "刪除成功，即將跳轉登入頁面...",
    },

    forgotPassword: {
        title: '忘 記 密 碼',
        enterEmail: '電子郵件',
        enterCode: '郵箱驗證碼',
        sendEmailCode: '發送驗證碼',
        enterEmailErr: '請輸入電子郵件',
        enterEmailErr2: '請輸入正確的電子郵件信箱',
        enterCodeErr: '請輸入信箱驗證碼',
        enterPassword: '新密碼',
        enterPasswordErr: '請輸入新密碼',
        enterPasswordErr2: '密碼由8~18位英文字母、數字、特殊符號組成',
        enterBtn1: '取消',
        enterBtn2: '確認',
        forgotPasswordSuccess: '修改成功，即將跳轉登入頁面...'
    },
    coinDetails: {
        title: "幣種詳情",
        tab1: '交易數據',
        tab2: '幣種信息',
        trade_txt1: "資金流向分析",
        trade_txt2: "持倉分析",
        trade_txt3: "多空比例",
        trade_txt4: "大戶持倉",
        trade_txt5: "大戶流動性",
        trade_txt6: "大戶交易",
        trade_txt7: "大戶持倉分佈",
        topInfo1: "24H漲跌幅",
        topInfo2: "24H最高價",
        topInfo3: "24H最低價",
        topInfo4: "交易量",
        topInfo5: "24H成交額",
        topInfo6: "24H開盤價",
        topInfo7: "歷史最低價",
        bottomInfo1: "幣種",
        bottomInfo2: "幣種全稱",
        bottomInfo3: "官網連結",
        bottomInfo4: "歷史最高價格",
        bottomInfo5: "歷史最低價格",
        bottomInfo6: "流通量",
        bottomInfo7: "發行總量",
        bottomInfo8: "最大供應量",
        bottomInfo9: "上市時間",
        bottomInfo10: "Telegram",
        bottomInfo11: "白皮書連結",
        bottomInfo12: "熱度排名",
        bottomInfo13: "市值排名",
    },
    coinTrade: {
        title1: '資金流向分析',
        title2: '24小時資金淨流入',
        title3: '5日主力淨流入',
        title4: '槓桿借貸存量增速',
        title5: '槓桿多空比',
        title6: '逐倉借貸比',
        tableTh11: '訂單',
        tableTh12: '買入',
        tableTh13: '賣出',
        tableTh14: '淨流入',
        tableTh15: '大單',
        tableTh16: '中單',
        tableTh17: '小單',
        tableTh18: '總計',
        chart11: '大單買入',
        chart12: '中單買入',
        chart13: '小單買入',
        chart14: '大單賣出',
        chart15: '中單賣出',
        chart16: '小單賣出',
    },
    insdetail: {
        title: '銘文詳情',
        topInfo1: '市值',
        topInfo2: '總交易額',
        topInfo3: '24H交易額',
        topInfo4: '持有人數',
        topInfo5: '成交比數',
        topInfo6: '在記憶池',
        topInfo7: '進度',
        bottomInfo1: '名稱',
        bottomInfo2: '總供應量',
        bottomInfo3: '部署銘文 ID',
        bottomInfo4: '編號',
        bottomInfo5: '單次鑄造上限',
        bottomInfo6: '創建者',
        bottomInfo7: '結尾銘刻編號',
        bottomInfo8: '精度',
        bottomInfo9: '創建時間',
        tab1: '交易歷史',
        tab2: '總覽',
        cycle1: '24 小时',
        cycle2: '7 天',
        cycle3: '30 天',
    },
    swap: {
        title: '兌換',
        pay: '支付',
        receive: '預計收到',
        reverse: '切換兌換方向',
        title1: '交換',
        title2: '連接錢包',
        title3: '斷開錢包',
        title4: '返回',
        title5: '滑點',
        title6: '預估網絡費',
        title7: '交換',
        title8: '餘額不足',
        title9: '參考匯率',
        msg1: '錢包已連接',
        msg2: '錢包已斷開',
        msg3: '請輸入有效的金額',
        msg4: '請先連接錢包',
        msg5: '請打開 OKX 錢包以簽署交易',
        msg6: '兌換成功完成！',
    },
    newCoinDetails: {
        topInfo1: '流通量',
        topInfo2: '流通率',
        topInfo3: '發售數量',
        topInfo4: '發行總量',
        topInfo5: '24小時漲幅',
        topInfo6: '最新價格',
        topInfo7: '發售價格',
        topInfo8: '預售時間',
        topInfo9: '上幣平台',
        topInfo10: '發售佔比',
        topInfo11: '直達連結',
        listTitle: '市場行情',
        list1: '交易平台',
        list2: '幣對',
        list3: '24H交易量',
        list4: '24H交易額($)',
        list5: '佔比',

"title": "新幣詳情"
},
    platformDetails: {
        title: '平台詳情',
        volumn24h: '24H交易額',
        title1: '簡介',
        content1: '成立時間：',
        content2: '註冊地：',
        content3: 'KYC認證',
        content4: '量化接口',
        content5: '資產',
        content6: '交易對數量',
        content7: '官網',
        isTrue: '是',
        isFalse: '否',
        title2: '交易支持',
        content8: '現貨交易',
        content9: '合約交易',
        content10: '場外交易',
        content11: '法幣交易',
        title3: '相關連結',
        content12: 'Facebook',
        content13: 'Twitter',
        content14: 'Reddit',
        content15: 'Telegram',
    },
    topHome: {
        marketSentiment: '市場情緒',
        sentimentDetails: '查看詳情',
        sentimentUnavailable: '暫無數據',
        sentimentIndexBlock1: '情緒指數',
        sentimentIndexBlock1_1: '極度恐慌',
        sentimentIndexBlock1_2: '恐慌',
        sentimentIndexBlock1_3: '中性',
        sentimentIndexBlock1_4: '貪婪',
        sentimentIndexBlock1_5: '極度貪婪',
        sentimentIndexBlock2: 'BTC持倉多空',
        sentimentIndexBlock2_1: '看多優勢',
        sentimentIndexBlock2_2: '看空優勢',
    },
    market: {
        tabs1: '熱門',
        tabs2: '漲幅',
        tabs3: '跌幅',
        tabs4: '新幣',
        tabs5: '飆升',
        tabs6: '市值',
        tabs7: '成交額',
        popularTh1: "幣種/24H交易量",
        popularTh2: "價格/24H成交額",
        popularTh3: "24H變動",
        newCoinTh1: "幣種/上市時間",
        newCoinTh2: "價格/24H成交額",
        newCoinTh3: "24H變動/交易量",
        marketTh1: "幣種/市值",
        marketTh2: "價格/24H成交額",
        marketTh3: "24H變動/交易量"
    },
    platform: {
        tabs1: '全球交易所資產排行',
        exchangeTableTh1: '平台',
        exchangeTableTh2: '資產',
        exchangeTableTh3: '官網',
    },
    manyEmpty: {
        overviewHint: "從交易量、帳戶與持倉，觀察多空力量的變化。",
        topTraders: "大戶分析",
        latestRatio: "最新多空比",
        balanced: "多空平衡",
        longBias: "多方較多",
        shortBias: "空方較多",
        interval: "時間週期",
        chartView: "圖表顯示",
        shareView: "佔比",
        loading: "載入中…",
        failed: "暫時無法載入",
        noData: "此條件暫無數據",
        retry: "重試",
        touchHint: "按住圖表查看數據",

        title1: '多空交易量比',
        title2: '多空人數比',
        title3: '大户多空賬戶比',
        title4: '大户多空持倉比',
        progress1: '多頭：',
        progress2: '空頭：',
        tableTh1: '交易所',
        tableTh2: '比例',
        tableTh3: '多頭占比',
        tableTh4: '空頭占比',
        msg1: '多空比',
        msg2: '多頭',
        msg3: '空頭',
        msg4: '人數比',
        msg5: '多倉人數%',
        msg6: '空倉人數%',
        msg7: '賬戶比',
        msg8: '多倉賬戶%',
        msg9: '空倉賬戶%',
        msg10: '持倉比',
        msg11: '多頭持倉%',
        msg12: '空頭持倉%',
    },
    whale: {
        holdingsTitle: '灰階持倉列表',
        holdingsTitle2: '更新時間：',
        holdingsTh1: '持倉變動',
        holdingsTh1_1: '1天',
        holdingsTh1_2: '7天',
        holdingsTh1_3: '30天',
        holdingsTh2: '溢價率',
        holdingsTh3: '持倉幣數量',
        holdingsTh4: '持倉價值',
        contractTitle: '合約總持倉',
        contractTh1: '交易所',
        contractTh2: '持倉價值($)',
        contractTh3: '持倉數',
        contractTh4: '15分鐘變化',
        contractTh5: '1天變化',
        exchangeTitle: '交易所餘額清單',
        exchangeTh1: '交易所',
        exchangeTh2: '錢包數',
        exchangeTh3: '24H變化',
        exchangeTh4: '7天變化',
        exchangeTh5: '30天變化',
        statistics1: '總市值',
        statistics2: '24小時交易量',
        statistics3: '24小時最低價',
        listRight1: '轉出地址：',
        listRight2: '轉入地址：',
        listRight3: '轉帳數量：',
    },
    autosearch: {
        msg: '搜索',
        msg1: '輸入關鍵字(交易所，幣名稱)',
        msg2: '清空',
        msg3: '沒有更多數據',
        msg4: '未找到相關數據',
    },
    burst: {
    explorerView: "清算圖表",
    explorerheatmap: "熱力圖",
    explorermap: "清算地圖",
    explorerOtherLeverage: "其他槓桿",
    explorerCumulativeLong: "累積多頭清算量",
    explorerCumulativeShort: "累積空頭清算量",
    explorerClose: "收起",
    explorerExpand: "放大圖表",
    explorerCoin: "幣種",
    explorerScope: "交易所",
    explorerPair: "單一交易所",
    explorerAll: "全市場",
    explorerEstimate: "模型估算清算區",
    explorerPrice: "最新參考價",
    explorerAbove: "上方主要熱區",
    explorerBelow: "下方主要熱區",

        currentPrice: '當前價格：',
        liquidationTip1: '累計多單清算强度',
        liquidationTip2: '累計空單清算强度',
        liquidationTip3: '10x杠杆',
        liquidationTip4: '25x杠杆',
        liquidationTip5: '50x杠杆',
        liquidationTip6: '100x杠杆',
        heatmapTop: '綜合Binance、Huobi、OKX三大交易所數據，{0}USDT爆倉最大點位在{1}附近，爆倉價值為{2}USDT，請注意資金風險',
        toBurstHeat: '詳情',
        heatmapMaximum: '清算強度上限',
        heatmapMinimum: '下限',
        heatmapKLine1: 'k線',
        heatmapKLine2: '清算強度',
        heatmapTip1: '價格',
        heatmapTip2: '清算強度',
        kLineTip1: '開盤價',
        kLineTip2: '收盤價',
        kLineTip3: '最高價',
        kLineTip4: '最低價',
        noLogin: '登入後查看熱力圖，',
        toLogin: '去登入',
        topBlockH4: '1H爆倉',
        topBlockH41: '4H爆倉',
        topBlockH42: '12H爆倉',
        topBlockH43: '24H爆倉',
        topBlockP: '多單佔比',
        rankingTitle: '最近24H，爆倉排行：',
        rankingTh1: '交易所',
        rankingTh2: '爆倉數量',
        rankingTh3: '爆倉USD',
        rankingTh4: '多單USD',
        rankingTh5: '空單USD',
        coinStatisticsH4: '各幣種爆倉統計',
        coinStatisticsT1: '1H',
        coinStatisticsT2: '4H',
        coinStatisticsT3: '24H',
        exchangeProportionH4: '全網交易所爆倉佔比',
        exchangeProportionT1: '4H',
        exchangeProportionT2: '12H',
        exchangeProportionT3: '24H',
        heatmapDetailsList1Top: '空',
        heatmapDetailsList1Bottom: '多',
        heatmapDetailsList1: '方向：',
        heatmapDetailsList2: '價格：',
        heatmapDetailsList3: '清算：',
        coinStatisticsDetailsTh1: '幣種',
        coinStatisticsDetailsTh2: '多單爆倉',
        coinStatisticsDetailsTh3: '空單爆倉',
        coinStatisticsDetailsTh4: '時間',
    },
    rate: {
        title1: "資金費率",
        type1: "持倉加權",
        type2: "成交額加權",
        price: '价格',
        newTitle: '交易所當前資金費率列表',
        newTableTh1: '幣種',
        newTableTd1: '預測費率',
        tableTh1Old: '交易所',
        tableTh2Old: '當前費率',
        tableTh3Old: '最高費率',
        tableTh4Old: '最低費率',
    },
    application: {
        leftNav1: '應用',
        leftNav2: '錢包',
        leftNav3: '社交',
        visit: '前往',
        empty: '暫無內容',
        download: '下載',
        register: '註冊'
    },
    publicChain: {
        loadFailed: '載入失敗，請重試',
        retry: '重試',

        tableTh1: '配對/市值',
        tableTh2: '價格/成交量',
        tableTh3: '漲幅/時間',
    },
    inscription: {
        typeAll: '全部',
        tableTh1: '序號',
        tableTh2: '代幣名稱',
        tableTh3: '持有人',
        tableTh4: '總交易次數',
        tableTh5: '價格',
    },
    smartMoney: {
        swipe1: '讓聰明錢幫我們打工',
        swipe2_1: '專為幣圈新手訂製',
        swipe2_2: '助力散戶把握機會',
        listTip: '7x24H監控',
        list1Title: 'Top 100 高頻交易',
        list1Msg: '8大公鏈綜合收益/收益率排名前100',
        list2Title: '明星聰明錢',
        list2Msg: '全球知名人士/公鏈創辦人/知名機構地址追蹤',
        list3Title: '一級聰明錢',
        list3Msg: '一級市場收益率較高/較穩定的聰明錢',
        list4Title: '自訂聰明錢',
        list4Msg: '用戶自行新增的追蹤錢包位址',
    },
    smartMoneyTop100: {
        topTip: '綜合各大DEX近30天分析資料。餘額僅供參考！ ',
        amountUsd: '代幣總勝率',
        floatProfit: '交易額',
        floatProfitPercent: '交易數',
        profit: '盈利',
        profitPercent: '盈利率',
        collectTo: '收藏',
        collectCancel: '取消收藏',
        noLogin: '登入後可查看追蹤全球前100位收益最高的聰明錢，',
        toLogin: '去登入',
    },
    smartMoneyStar: {
        title: '明星聰明錢',
    },
    smartMoneyOneLevel: {
        title: '一級聰明錢',
    },
    smartMoneyCustom: {
        title: '自訂聰明錢',
        addName: '名稱：',
        addNameRules: '請輸入名稱',
        addAddress: '地址：',
        addAddressRules: '請輸入地址',
        addComment: '備註：',
        addConfirm: '確認',
        addSuccess: '添加成功！ ',
        delBtn: '刪除',
        delSuccess: '刪除成功！ '
    },
    smartMoneyDetails: {
        queryTokenAll: '全部',
        return: '返回',
        dexAddress: '地址：',
        dexHash: '交易hash：',
        dexChainName: '鏈名稱：',
        dexTransactionAmount: '交易價值：',
        dexTrackerIn: '轉入合約：',
        dexTrackerOut: '轉出合約：',
        dexTrackerType: '交易方向：',
        dexTrackerTypeCon: '{0}{1} 兌換為 {2}{3}',
        dexTransactionTime: '交易時間：',
        ordinaryHash: '交易hash：',
        ordinaryFrom: '發送者地址：',
        ordinaryTo: '接收者地址：',
        ordinarySymbol: '幣種名稱：',
        ordinaryAmount: '轉帳數量：',
        ordinaryTime: '時間：',
    },
    consult: {
        topNav1: '快訊',
        topNav2: '公告',
        topNav3: '新聞',
        detailsShare: '分享：',
        detailsTime: '時間'
    },
    my: {
        headPictureSuccess: '修改成功！ ',
        toSignIn: '去簽到',
        wallet: '簽到錢包餘額',
        details: '詳情',
        memberTitle: '會員中心',
        memberItem1: '合約檢查',
        memberItem2: '提幣',
        memberItem3: '線上客服',
        memberItem4: '邀請連結',
        installMetaMask: '請先安裝 Metamask！ ',
        nav1: '收藏',
        nav2: '追蹤',
        nav3: '團隊',
        nav4: '論壇',
        nav5: '工具',
        nav6: '語言',
        nav7: "登出",
        nav8: '綁定API',
        nav9: '打新機器人',
        nav10: "刪除帳號",
        nav11: "登出",
    },
    signIn: {
        title: '已簽到{0}天',
        btn: '立即簽到',
        tip1: "瀏覽平台{0}分鐘，即可領取簽到獎勵",
        tip2: '（您已瀏覽{0}分鐘{1}秒）',
        success: '簽到成功！ ',
        recordTitle: '簽到記錄',
        recordListContent: '時間：',
    },
    signInRecord: {
        title: '錢包明細',
        selectAll: '全部',
        typeSelect1: '簽到獎勵',
        typeSelect2: '直推獎勵',
        typeSelect3: '團隊獎勵',
        typeSelect4: '申請提現扣除',
        typeSelect5: '系統駁回增加',
    },
    contractCheck: {
        riskAssessment: '風險評估',
        riskInspection: '風險檢查',
        enterPlaceholder: '請輸入合約地址',
        enterBtn: '檢查',
        checkNFT1: ['無惡意NFT', '惡意NFT'],
        checkNFT2: ['未開源', '已開源'],
        checkNFT3: ['無代理合約', '有代理合約'],
        checkNFT4: ['未驗證', '已驗證'],
        checkNFT5: ['不是著名的、值得信賴的NFT', '著名的、值得信賴的NFT'],
        checkToken1: ['不具有修改最大交易金額或最大代幣持倉的功能', '具有修改最大交易金額或最大代幣持倉的功能'],
        checkToken2: ['所有權不可以收回', '所有權可以收回'],
        checkToken3: ['合約無隱藏所有者', '合約有隱藏所有者'],
        checkToken4: ['不具有限制單一地址最大交易量或最大持倉量的功能', '具有限制單一地址最大交易量或最大持倉量的功能'],
        checkToken5: ['令牌不是蜜罐', '令牌是蜜罐'],
        checkToken6: ['代幣不可以在去中心化交易所交易', '代幣可以在去中心化交易所交易'],
        checkToken7: ['合約沒有能力鑄造代幣', '合約有能力鑄造代幣'],
        checkToken8: ['未開源', '已開源'],
        checkToken9: ['不是代理', '是代理'],
        checkToken10: ['合約所有者不可以更改代幣持有者餘額', '合約所有者可以更改代幣持有者餘額'],
        checkToken11: ['不可以為每個分配的地址設定不同的稅率', '可以為每個分配的地址設定不同的稅率'],
        checkToken12: ['合約不可以自毀', '合約可以自毀'],
        checkToken13: ['合約不具交易冷卻機制', '合約具有交易冷卻機制'],
        checkToken14: ['不可以透過代幣合約暫停交易', '可以透過代幣合約暫停交易'],
        checkToken15: ['該代幣不是著名且值得信賴的代幣', '該代幣是著名且值得信賴的代幣'],
        botToken1: '所有者地址',
        botToken2: '所有者的餘額',
        botToken3: '所有者持有代幣的百分比',
        botToken4: '供應數量',
        botNFT1: '總交易量',
        botNFT2: '持有者數',
        botNFT3: '最高價',
        botNFT4: '24小時平均價格',
        botNFT5: '24小時最低價',
    },
    withdrawal: {
        title: '提幣',
        titleTip: '提款位址必須是TRON（TRC-20）鏈的錢包位址。填寫其他鏈的錢包位址將導致永久丟失且無法恢復。 ',
        withdrawalAddress: '您的提款地址：',
        inputWithdrawalAddress: '請輸入提款地址',
        number: '數量',
        inputNumber: '請輸入數量',
        inputNumberErr: '餘額不足',
        balance: '餘額',
        actualReceipt: '實際到帳：',
        gas: '手續費：',
        tip: '最低提領{0}USDT，提現手續費{1}%。 ',
        confirm: '確定',
        explain: '網路交易需要0-2小時，網路確認不包括在內',
        submitSuccess: '提交成功'
    },
    withdrawalRecord: {
        title: '提幣記錄',
        list1: '地址：',
        list2: '網路：',
        list3: '幣種：',
        list4: '數量：',
        list5: '手續費：',
        list6: '狀態：',
        list7: '時間：',
        status0: '待審核',
        status1: '透過',
        status2: '駁回',
    },
    bindingApi: {
        title: '綁定API',
        tip: '交易所創建API要求必須綁定IP',
        listTitle: '綁定清單',
        unBindBtn: '解綁',
        availableBalance: '可用餘額：',
        bindFrom1: '選擇交易所：',
        bindFrom1Err: '請選擇交易所',
        bindFrom2Err: '請輸入Api key',
        bindFrom3Err: '請輸入Secret key',
        bindFrom4Err: '請輸入PassPhrase(OKX必填)',
        bindFrom5: '備註：',
        bindFrom5Err: '請輸入備註',
        bindSuccess: '綁定成功',
        unBindSuccess: '解綁成功',
    },
    myAsset: {
        disconnect: '斷開連接'
    },
    collect: {
        title: '收藏',
        amountUsd: '餘額',
        floatProfit: '浮盈',
        floatProfitPercent: '浮盈率',
        profit: '盈利',
        profitPercent: '盈利率',
        cancel: '取消收藏',
        cancelSuccess: '取消成功！ ',
    },
    trace: {
        title: '追蹤',
        list1: '公鏈名稱：',
        list2: '代幣名稱：',
        list3: '地址：',
        listDel: '刪除',
        listDelSuccess: '刪除成功！ ',
    },
    team: {
        title: '團隊',
        topInfo1: '直推人數',
        topInfo2: '團隊人數',
        topInfoUnit: '人',
        tableTh1: '使用者名稱',
        tableTh2: '註冊時間',
        inviteCode: '邀請碼',
        empty: '還沒有直推成員。分享邀請連結即可加入團隊。',
    },
    forum: {
        title: '論壇',
        toForumPublishNoLogin: '請先去登錄，登入後可發佈！ ',
        publishTitle: '發布論壇',
        publishContentPlaceholder: '請輸入內容',
        publishSuccess: '發布成功！ ',
        publishConfirm: '發布',
        forumList1: '全文',
        detailsTitle: '論壇正文',
        detailsCommentTitle: '評論',
        detailsCommentInputPlaceholder: '請輸入評論內容',
        detailsCommentInputSuccess: '發送成功！ ',
        detailsCommentInputBtn: '發送',
    },
    tool: {
        title: '工具',
        tool1: 'BTC公司持倉',
        tool2: '情緒指數',
        tool3: '門頭溝監控',
        tool4: '場外價格',
        tool5: '外盤資料',
        tool6: '大戶增倉',
        tool7: '大戶減倉',
        tool8: '穩定幣',
        tool9: '區塊鏈瀏覽器',
    },
    toolCompanyHoldings: {
        title: 'BTC持倉機構',
        titleSub1: '全球公司BTC持倉數據',
        globalDataT1: 'BTC持倉公司',
        globalDataD1: '家',
        globalDataT2: '公司總持倉',
        globalDataD2: '近7日變化：',
        globalDataT3: '持倉總價值',
        globalDataD3: '近7日變化：',
        globalDataT4: '持倉佔BTC總市值',
        globalDataD4: '7日前佔比：',
        titleSub2: 'BTC持倉公司',
        listTh1_1: '持倉價值($)/',
        listTh1_2: '佔BTC市值',
        listTh2_1: '持倉BTC/',
        listTh2_2: '近7日持倉變動',
        listTh3_1: '總持倉成本/',
        listTh3_2: '平均成本($)',
    },
    toolSentimentIndex: {
        title: '情緒指數',
        titleSub1: '恐慌與貪婪指數',
        titleSub1_1: 'BTC與重要主流幣的恐慌與貪婪指數',
        gauge1: '極度恐慌',
        gauge2: '恐慌',
        gauge3: '中性',
        gauge4: '貪婪',
        gauge5: '極度貪婪',
        titleSub2: '歷史指數',
    },
    toolMTGoxMonitor: {
        title: '門頭溝監控',
        titleSub1: '門頭溝(MTGox)BTC冷錢包',
        topLabel1: '原持有BTC總量',
        topLabel1Span: '原價值',
        topLabel2: '現剩餘BTC總量',
        topLabel2Span: '現價值',
        topLabel3: '持有BTC變動量',
        titleSub2: 'BTC冷錢包鏈上轉出記錄',
        tableTh1: '交易時間',
        tableTh2: '冷錢包地址',
        tableTh3: '轉帳BTC數量',
    },
    toolOutsidePrice: {
        title: '場外價格',
        th1: '交易所',
        th2: '成交均價',
        th3: '溢價',
    },
    toolOutsideDisk: {
        title: '外盤資料',
        itemTitleSpan: '更新',
        itemTitle2: '開盤時間：',
        beijingTime: '北京時間',
        nextDay: '次日',
        itemInfo1: '昨收',
        itemInfo2: '今開',
        itemInfo3: '今日成交量',
        itemInfo4: '今日最高',
        itemInfo5: '今日最低',
        itemInfo6: '近一年最高',
        itemInfo7: '近一年最低',
        names: {
            BRENT: '布倫特原油',
            DJI: '道瓊斯指數',
            HKHSI: '香港恒生指數',
            INX: '標普500指數',
            IXIC: '納斯達克綜合指數',
            N225: '日經225',
            SH000001: '上證指數',
            SH000300: '滬深300指數',
            WTI: 'WTI原油',
            XAU: '倫敦金（現貨黃金）',
        },
    },
    toolLargeIncrease: {
        title: '大戶增倉',
        tableTh1: '幣種',
        tableTh2: '24H漲跌',
        tableTh3: '24H持倉佔比',
        tableTh4: '週持倉佔比',
        tableTh5: '月持倉佔比',
        tableTh6: '全球指數($)',
        tableTh7: '前10持倉佔比',
        tableTh8: '前20持倉佔比',
        tableTh9: '前50持倉佔比',
        tableTh10: '前100持倉佔比',
    },
    toolLargeDecrease: {
        title: '大戶減倉',
        tableTh1: '幣種',
        tableTh2: '24H漲跌',
        tableTh3: '24H持倉佔比',
        tableTh4: '週持倉佔比',
        tableTh5: '月持倉佔比',
        tableTh6: '全球指數($)',
        tableTh7: '前10持倉佔比',
        tableTh8: '前20持倉佔比',
        tableTh9: '前50持倉佔比',
        tableTh10: '前100持倉佔比',
    },
    toolStableCoin: {
        title: '穩定幣',
        UsdTopInfo1: 'USDT場外均價',
        UsdTopInfo2: '美元匯率',
        UsdTopInfo3: 'USDT溢價率',
        UsdTitleSub1: 'USDT相關指數走勢',
        UsdIndexQuery1: '7天',
        UsdIndexQuery2: '30天',
        UsdTitleSub2: 'USDT溢價相關走勢',
        relatedTitleSub1: '穩定幣概況',
        relatedTopTh1: '幣種',
        relatedTopTh2: '場外均價(¥)/溢價費率',
        relatedTopTh3: '當前流通量',
        relatedTitleSub2: '穩定幣流通量',
        relatedQuery1: '30天',
        relatedQuery2: '近一年',
        relatedTitleSub3: '穩定幣流通量佔比',
        relatedTitleSub4: '穩定幣鏈上發行',
        relatedBottomListH4_1: '增發',
        relatedBottomListH4_2: '銷毀',
        relatedBottomListHash: '交易哈希：',
    },
    toolBlockChainBrowser: {
        title: '區塊鏈瀏覽器',
    },
    firmOffer: {

        titleLabel0: '合約地址：',
        titleLabel1: '持幣地址數',
        titleLabel2: '獨立交易地址數',
        titleLabel3: '交易筆數',
        titleLabel4: '成交額',
        titleLabel5: '流動性',
        titleLabel6: '總市值',
        titleLabel7: '創建時間',
        titleLabel8: '總鎖倉市值',
        tabs1: '交易歷史',
        tabs2: '池子變化',
        tabs3: '持幣地址',
        tabs4: '資金',
        transactionTh1: '時間',
        transactionTh2: '價格($)',
        transactionTh3: '成交量($)',
        transactionTh4: '數量',
        transactionTh5: '錢包地址',
        transactionAddTrace: '確定跟蹤此錢包地址嗎？',
        transactionAddTraceSuccess: '添加成功！',
        tag1: '買 入',
        tag2: '賣 出',
        tag3: '增加',
        tag4: '減少',
        poolTip: '默認顯示第一個池子數據',
        poolTh1: '時間',
        poolTh2: '類型',
        poolTh3: '成交量($)',
        poolTh4: '數量',
        poolTh5: '錢包地址',
        poolCurrent: '總地址數',
        Explain1: '總地址數：',
        Explain2: '前10占比：',
        Explain3: '狙擊手數：',
        Explain4: '可疑持幣地址數：',
        positionTh1: '排名',
        positionTh2: '錢包地址',
        positionTh3: '持有比例',
        positionTh4: '數量',
        positionTh5: '24小時變化',
        positionTh6: '區塊信息',
        financeType1: 'Top 買家',
        financeType2: 'Top 賣家',
        financeTh1buy: '淨買入',
        financeTh1sell: '淨賣出',
        financeTh2buy: '買入金額($)',
        financeTh2sell: '賣出金額($)',
        financeTh3: '用戶',
        addTrace: '確認追蹤當前地址嗎？',
        addTraceSuccess: '添加成功！',

"title": "代幣詳情"
},
    smartMoneySmall: {
        cycle1: '1分',
        cycle2: '5分',
        cycle3: '30分',
        cycle4: '1時',
        cycle5: '4時',
        cycle6: '1天',
        klineIndicator1: '買入',
        klineIndicator2: '賣出',
        tableTh1: '購買數量',
        tableTh2: '購買金額',
        tableTh3: '賣出數量',
        tableTh4: '賣出金額',
        tableTh5: '浮盈',
        tableThAddress: '地址：',
        detailsReturn: '返回列表',
        detailsAddress: '地址：',
        detailsTokenAddress: '代幣地址：',
        detailsChainName: '鏈名稱：',
        detailsTrackerType: '交易方向：',
        detailsTrackerTypeVal1: '買入',
        detailsTrackerTypeVal2: '賣出',
        detailsAmount: '購買數量：',
        detailsAmountUsd: '購買金額USD：',
        detailsTransactionTime: '交易時間：',
        detailsHash: '交易hash：',
    },
    hitNewRobot: {
        title: '打新機器人',
        topImg1: '智慧時代，領創科技未來',
        topImg2: '打新機器人',
        topImg3: '9月30日',
        topImg4: '正式上線',
        topImg5: '查看規則>>',
        type1: '交易所打新清單',
        hitNewlistTh1: '代幣資訊',
        hitNewlistTh2: '代幣價格',
        hitNewlistTh3: '池子比例',
        hitNewlistTh4: '初始/剩餘',
        hitNewlistTh5: '時間',
        createBtn: '創建',
        createTitle: '創建機器人',
        createLabel1: '交易所名稱：',
        createLabel2: '幣對所名稱：',
        createLabel3: '上幣時間：',
        createLabel7: '可用餘額：',
        createLabel4: '預計購買數量：',
        createLabel5: '預計購買價格：',
        createLabel6: '搶購時間：',
        createLabel4Err: '請輸入預計購買數量',
        createLabel5Err: '請輸入預計購買價格',
        createLabel6Err: '請選擇搶購時間',
        createLabel6Select1: '選擇年月日',
        createLabel6Select2: '選擇時分秒',
        createTip: '購買價值必須>=10USDT',
        createSuccess: '創建成功！',
        type2: '機器人清單',
        robotListStatus1: '待執行',
        robotListStatus2: '已結束',
        robotListBinanceStatus1: '掛單成功',
        robotListBinanceStatus2: '掛單失敗',
        robotList1: '執行時間：',
        robotList2: '取消機器人',
        robotList3: '幣對',
        robotList4: '價格',
        robotList5: '數量',
        robotCancel: '取消成功',
    },
    hitNewRobotInfo: {
        title: '交易',
        title2: '交易歷史'
    },
    hitNewRobotRule: {
        title: '數位貨幣打新機器人模塊介紹',
        h2_1: '覈心優勢：',
        label1_1: '高效算灋：',
        label1_2: '深度綜合：',
        label1_3: '大資料處理：',
        label1_4: '智慧策略：',
        label1_5: '安全保障：',
        label1_6: '自動化交易：',
        label1_7: '優化體驗：',
        p1_1: '內寘高效算灋，毫秒級交易決策，精准捕捉市場動態。',
        p1_2: '綜合Binance、HTX、OKX等主流交易所API，確保數據全面準確。',
        p1_3: '利用Apache Kafka與Flink科技，實时收集並處理市場數據。',
        p1_4: '結合TensorFlow或PyTorch框架，利用歷史資料與趨勢優化打新策略。',
        p1_5: '分佈式架構，多重加密技術，保障用戶數據與交易安全。',
        p1_6: '未來探索智慧合約與跨鏈科技，實現DEX自動化交易與高效資產管理。',
        p1_7: '持續優化介面與交互設計，提供直觀數據視覺化工具，提升用戶體驗。',
        h2_2: '會員陞級標準：',
        label2_1: 'v0 → v1：',
        label2_2: 'v1 → v2：',
        label2_3: 'v2 → v3：',
        label2_4: 'v3 → v4：',
        label2_5: 'v4 → v5：',
        label2_6: 'v5 → v6：',
        label2_7: 'v6 → v7：',
        p2_1: '直推3人，團隊達到100人。',
        p2_2: '直推5人，團隊達到200人。',
        p2_3: '直推5人，其中兩人達到v2。',
        p2_4: '直推5人，其中兩人達到v3。',
        p2_5: '直推5人，其中兩人達到v4。',
        p2_6: '直推5人，其中兩人達到v5。',
        p2_7: '直推5人，其中兩人達到v6。',
        h2_3: '機器人發放標準：',
        label3_1: 'V1',
        label3_2: 'V2',
        label3_3: 'V3',
        label3_4: 'V4',
        label3_5: 'V5',
        label3_6: 'V6',
        label3_7: 'V7',
        p3_1: '獲得1個機器人。',
        p3_2: '獲得3個機器人。',
        p3_3: '獲得5個機器人。',
        p3_4: '獲得6個機器人。',
        p3_5: '獲得7個機器人。',
        p3_6: '獲得9個機器人。',
        p3_7: '獲得10個機器人，並額外贈送5個，總計15個機器人。',
        h2_4: '機器人有效運行條件：',
        label4_1: '持續簽到：',
        label4_2: '啟動條件：',
        label4_3: '簽到中斷：',
        p4_1: '會員需保持每日簽到，以確保機器人有效運行。',
        p4_2: '僅連續簽到會員可啟動打新服務。',
        p4_3: '若當日漏簽，次日打新機器人將停止運行，恢復簽到後次日零點自動啟動。',
        h2_5: '總結：',
        p5: '本平臺數位貨幣打新機器人模塊，通過高效算灋與智慧策略，為會員提供自動化、高效、安全的打新服務。隨著科技的不斷進步，我們將持續優化用戶體驗，拓展更多元化的打新選擇，助力會員實現資產增值'
    },
    invite: {
        title: '邀請好友',
        info1: '邀請好友加入報名/團隊',
        info2: '有機會獲得開啟機器人機會/推廣收益',
        info3: '嗨！歡迎來到 TokenTrend 平台',
        info4: '專為幣圈新手訂製 全新工具一鍵上手',
        btn: '複製邀請連結'
    }
,
    hyperliquid: {
        searchPlaceholder: '輸入錢包地址查詢持倉資訊...',
        searchBtn: '查詢',
        title: '鯨魚倉位監控',
        dataCount: '共 {0} 個大戶持倉',
        long: '做多',
        short: '做空',
        cross: '全倉',
        isolated: '逐倉',
        positionValue: '倉位價值',
        positionSize: '倉位大小',
        entryPrice: '開倉價格',
        markPrice: '標記價格',
        unrealizedPnl: '未實現盈虧',
        noData: '暫無資料',
        enterAddress: '請輸入錢包地址',
        enterValidAddress: '請輸入有效的錢包地址',
        copyAddress: '複製地址',
        whale: '巨鯨',
        explorer: '瀏覽器',
        accountTotalValue: '帳戶總價值',
        perpetual: '永續合約',
        freeMarginAvailable: '可用保證金',
        withdrawable: '可提取',
        totalPositionValue: '持倉總價值',
        leverageRatio: '槓桿倍數',
        marginUsed: '已用保證金',
        usedRatio: '使用率',
        perpTotalValue: '永續持倉總價值',
        positionsCount: '{0} 個倉位',
        avgMarginUsedRatio: '平均保證金使用率',
        directionBias: '方向偏向',
        longExposure: '多頭敞口',
        shortExposure: '空頭敞口',
        positionDistribution: '倉位分佈',
        longValue: '多頭價值',
        shortValue: '空頭價值',
        roe: 'ROE',
        upnl: '未實現盈虧',
        perpPositions: '永續倉位 ({0})',
        symbol: '幣種',
        entryAvgPrice: '開倉均價',
        margin: '保證金',
        fundingCost: '資金費用',
        noPositions: '暫無持倉',
        userAddressRequired: '用戶地址不能為空',
        addressCopied: '地址已複製',
        copyFailed: '複製失敗',
        bullish: '看多',
        bearish: '看空',
        neutral: '中性'
    },
"burstHeatmapDetails": {"title":"清算熱力圖"},
"burstCoinStatisticsDetails": {"title":"幣種清算統計"},
"forumPublish": {"title":"發佈文章"},
"forumDetails": {"title":"社群文章"},
"consultDetails": {"title":"文章詳情"}
}
